import styled from 'styled-components';
import { IconButton } from '@mui/material';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const PoweredByContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;

  margin: auto 0 20px 0;

  .powered-by {
    &__text {
      padding: 0 5px;
      font-size: 1.6rem;
      white-space: nowrap;
      color: ${p => p.theme.palette.primary.main};
    }

    &__logo img {
      width: 100px;
      margin-top: 5px;
    }
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  height: 90px;
  flex-shrink: 0;
  margin-bottom: 20px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
`;

export const Logo = styled.img`
  max-width: 150px;
  max-height: 80px;
`;

export const BurgerButton = styled(IconButton)`
  && {
    position: fixed;
    top: 25px;
    left: 0;
    z-index: 1101; //AppBar + 1
    padding: 12px;

    ${breakpoints.down('md')} {
      top: 12px;
    }
  }
`;

export const PartnersSelect = styled.div`
  padding: 0 10px 10px;
  margin-top: -10px;

  .MuiInputLabel-root {
    margin-bottom: 5px;

    svg {
      vertical-align: middle;
      font-size: 1.8rem;
    }
  }

  .MuiFormHelperText-root {
    font-size: 1.2rem;
  }
`;
